@if (initialized) {
    <div class="grid">
        <div class="col-12">

            <div class="flex justify-content-between align-items-center card">

                <div>
                    <mvs-multi-select-toolbar-component
                            *ngIf="statusEntries"
                            [statusEntries]="statusEntries"
                            [selectedStatus]="[selectedStatus]"
                            [totalCount]="totalCount"
                            (statusClick)="onStatusClick($event)"
                    ></mvs-multi-select-toolbar-component>
                </div>

                <div>
                    <p-select
                            [options]="billingAreaList"
                            [(ngModel)]="selectedBillingArea"
                            placeholder="Select Billing Area"
                            optionLabel="name"
                            (onChange)="handleBillingAreaChange($event)"
                    />
                </div>

            </div>
        </div>

        <div class="col-12">
            @if (billingRunReportWidget) {
                <mvs-widget
                        [widgetData]="billingRunReportWidget"
                        (onFieldObjectSelect)="handleObjectSelect($event)">
                </mvs-widget>
            }
        </div>
    </div>
}